import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import InfoTooltip from '../InfoTooltip';

const QuickPriceWarningIndicator = ({ messages, subject, onReview }) => {
  if (!messages.length) return null;
  const message = messages.join(' ');
  const label = `Avisos de ${subject}: ${message}`;
  const classes = 'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100 focus-visible:ring-2 focus-visible:ring-amber-500';
  const icon = <FiAlertTriangle aria-hidden="true" className="h-4 w-4" />;
  return onReview
    ? <button type="button" aria-label={label} title={message} onClick={onReview} className={classes}>{icon}</button>
    : <InfoTooltip label={label} message={message} triggerClassName={classes}>{icon}</InfoTooltip>;
};

export default QuickPriceWarningIndicator;
